import { combineReducers } from "redux";
import { FETCH_RECORDING_DETAILS_BEGIN, FETCH_RECORDING_DETAILS_FAILURE, FETCH_RECORDING_DETAILS_SUCCESS } from "../../actions/recordingDetails";
function initialize(state = false, action) {
    switch (action.type) {
        case FETCH_RECORDING_DETAILS_SUCCESS:
        case FETCH_RECORDING_DETAILS_FAILURE:
            return true;
        default:
            return state;
    }
}
function loading(state = 0, action) {
    switch (action.type) {
        case FETCH_RECORDING_DETAILS_BEGIN:
            return state + 1;
        case FETCH_RECORDING_DETAILS_SUCCESS:
            return state - 1;
        case FETCH_RECORDING_DETAILS_FAILURE:
            return state - 1;
        default:
            return state;
    }
}
export default combineReducers({
    initialize,
    loading
});
